import * as React from 'react';
import type { Notice as Interface } from '../../design/components';
import { randomMessageForTone, ShimmerText, StaticText } from '../shared/notice';

export const Notice: React.FC<Interface> = ({ state, tone = 'loading', animated, detail }) => {
  const [fallback] = React.useState(() => randomMessageForTone(tone));
  const [text, Icon] = state?.[0] ? [state[0], null] : fallback;
  const shouldAnimate = animated ?? tone === 'loading';

  return (
    <div className="flex flex-col items-center justify-center gap-3 p-8">
      <div className="flex items-center gap-2.5">
        {shouldAnimate
          ? <ShimmerText text={text} Icon={Icon} colors={['#6b7280', '#d1d5db']} iconColor="#9ca3af" />
          : <StaticText text={text} Icon={Icon!} color="#6b7280" iconColor="#9ca3af" />
        }
      </div>
      {detail && <span className="text-sm text-gray-400">{detail}</span>}
    </div>
  );
};
